export const TIME_LINE_MODES = {
  YEARS: {
    format: 'y',
    type: 'years'
  },
  MONTH: {
    format: 'MMMM yy',
    type: 'month'
  }
}
